import { render, staticRenderFns } from "./CustomerFormDesktopView.vue?vue&type=template&id=c469d29c&"
import script from "./CustomerFormDesktopView.vue?vue&type=script&lang=js&"
export * from "./CustomerFormDesktopView.vue?vue&type=script&lang=js&"
import style0 from "./CustomerFormDesktopView.vue?vue&type=style&index=0&id=c469d29c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports